define(['angular', 'modal', 'togglemodule', 'scrolltracker'], function () {
  var Modal = require('modal');
  var Tabs = require('togglemodule');
  var ScrollTracker = require('scrolltracker');
  var app = angular.module('App', []);

  app.directive('windowresize', ['$window', function($window) {
    return function($scope) {

      $scope.mobile = false;

       $scope.checkMobile = function() {
          var mobileSize = 992;
          $scope.mobile = ($scope.windowWidth <= mobileSize);
       };

       $scope.initializeWindowSize = function() {
          $scope.windowWidth = $window.innerWidth;
          $scope.checkMobile();
       };

       $scope.initializeWindowSize();

       return angular.element($window).bind('resize', function() {
          $scope.initializeWindowSize();
          return $scope.$apply();
       });
    };
  }]);

  app.directive('ngEnter', ['$window', function ($window) {
      return function (scope, element, attrs) {
          element.bind("keydown keypress", function (event) {
              if (event.which === 13) {
                  scope.$apply(function () {
                      scope.$eval(attrs.ngEnter);
                  });
                  event.preventDefault();
              }
          });
      };
  }]);

  var modal = Modal.apply(this, [app]);
  var tabs = Tabs.apply(this, [app]);
  var scrolltracker = ScrollTracker.apply(this, [app]);  
  return app;
});
